<forge-card telemetry="Card-PacketProgress-UtilityBilling" class="chart">
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">Packet Progress</h2>
        </div>
    </forge-toolbar>

    <div class="metadata-padding">
        <div fxLayoutAlign="space-between stretch">
            <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>

            <div *ngIf="hasData" fxLayout="row" fxLayoutAlign="space-between" class="content">

                <div *ngFor="let item of items; first as isFirst" fxFlex="50" class="chart">
                    <forge-divider *ngIf="!isFirst" class="tt-margin--bottom"></forge-divider>

                    <packet-progress-chart [item]="item"></packet-progress-chart>
                </div>
            </div>
        </div>

        <div [fxShow]="isLoaded && !hasData" fxLayoutAlign="center start" class="footer">
            There are no packets in progress
        </div>
    </div>
</forge-card>